



'use client';

import type React from 'react';
import { Box } from '@chakra-ui/react';
import { useContext, useEffect, useRef, useState } from 'react';
import { Buttons } from '../../../../../src/components/ui/button';
import { Input } from '../../../../../src/components/ui/input';
import { Card } from '../../../../../src/components/ui/card';
import { Badge } from '../../../../../src/components/ui/badge';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import svgPaths from '../../../../../src/imports/svg-knollny4nu';
import toast, { Toaster } from 'react-hot-toast';
import imgBackground from '../../../../../src/assets/img/NewUI_Images/background.png';
import imgPlatform from '../../../../../src/assets/img/NewUI_Images/platform.png';
import { useColor } from '../../../../../src/components/ui/ColorContext';
import * as THREE from 'three';
import { Canvas } from 'react-three-fiber';
import { ProfileContext } from '../EntirePreview';
import { updateLearnerNickName } from 'utils/gameApplication/gamePlayService';
import BtnClickSound from "../../../../assets/adiuo/simple-btn-click.mp3";
import { ScoreContext } from '../GamePreview';
import { updateScreenActivity } from '../common';


const NavigationArrow: React.FC<{
  direction: 'left' | 'right';
  onClick: () => void;
  isBlinking?: boolean;
}> = ({ direction, onClick, isBlinking }) => {
  const { primaryColor } = useColor();

  const shouldBlink = direction === "right" && isBlinking;

  return (
    <Buttons
      variant="ghost"
      size="sm"
      onClick={onClick}
      className="h-[2.125rem] w-[3.125rem] rounded-3xl px-4 py-2 transition-all duration-200 hover:scale-110"
      style={{
        background: `linear-gradient(${
          direction === 'left' ? '275.041deg' : '90deg'
        },
        rgba(${hexToRgb(primaryColor)}, 0.6) 7.25%, rgba(${hexToRgb(
          primaryColor,
        )}, 0.15) 84.803%)`,
        border: `1px solid ${primaryColor}`,

        boxShadow: shouldBlink
          ? `0 0 10px ${primaryColor},
             0 0 25px ${primaryColor},
             0 0 40px ${primaryColor}`
          : `0px 0px 15.9542px 0px rgba(${hexToRgb(
              primaryColor,
            )}, 0.3)`,

        animation: shouldBlink ? "blinkGlow 1s infinite" : "none",
      }}
    >
      {direction === 'left' ? (
        <ChevronLeft className="!h-4 !w-4 text-white" />
      ) : (
        <ChevronRight className="!h-4 !w-4 text-white" />
      )}
    </Buttons>
  );
};


const SkipButton = ({ onClick }: { onClick: () => void }) => (
  <button
    onClick={onClick}
    className="absolute top-6 right-6 z-[999999] rounded-full px-5 py-2 text-sm font-semibold text-white backdrop-blur-md"
    style={{
      background: 'rgba(0,0,0,0.55)',
      border: '1px solid rgba(255,255,255,0.3)',
    }}
  >
    Skip
  </button>
);

  const hexToRgb = (hex: string): string => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) return '0, 255, 187'; // fallback to default green
  const r = Number.parseInt(result[1], 16);
  const g = Number.parseInt(result[2], 16);
  const b = Number.parseInt(result[3], 16);
  return `${r}, ${g}, ${b}`;
};
interface Character {
  id: number;
  name: string;
  stats: {
    attack: number;
    speed: number;
    defense: number;
    damage: number;
  };
  icon: 'ranking' | 'male' | 'female' | 'settings';
}

interface PlayGamesProps {
  formData?: any;
  state?: any;
  dispatch?: any;
  setDatas?: any;
  imageSrc?: any;
  setCurrentScreenId?: any;
  players?: any;
  setSelectedPlayer?: any;
  profileData?: any;
  setProfileData?: any;
  demoBlocks?: any;
  preloadedAssets?: any;
  currentScreenId: any;
  ModelPlayer: any;
  setLearnerPlayingDetails: any;
  learnerPlayList: any;
  backgroundtheme: any;
  selectedBackground: any;
  audioObj:any; 
  setAudioObj:any;
}


// Helper function to convert hex to RGB


const CharacterSelectionFutureTheme: React.FC<
  PlayGamesProps & {
    onNavigate?: (direction: 'left' | 'right') => void;
  }
> = ({
  formData,
  state,
  dispatch,
  setDatas,
  imageSrc,
  setCurrentScreenId,
  players,
  setSelectedPlayer,
  profileData,
  setProfileData,
  demoBlocks,
  preloadedAssets,
  currentScreenId,
  ModelPlayer,
  setLearnerPlayingDetails,
  learnerPlayList,
  backgroundtheme,
  selectedBackground,
  audioObj, 
  setAudioObj,
  onNavigate, // existing prop
}) => {
  const audioRef = useRef(null);
  const { setlearnerActivityrec,deviceInfo} = useContext(ScoreContext);
  const { primaryColor } = useColor();
    const [isTransitioning, setIsTransitioning] = useState(false);
  const [blackScreen, setBlackScreen] = useState(false);

  const [showFloatingHub, setShowFloatingHub] = useState(false);
  const [showQuestHub, setShowQuestHub] = useState(false);

  const useData = useContext(ProfileContext);


  const [formState, setFormState] = useState<any>({
    name: '',
  });
    const questVideoRef = useRef<HTMLVideoElement | null>(null);

  const videoRef = useRef<HTMLVideoElement | null>(null);
    const startPortalTransition = (
      actionAfterTransition: () => void,
      duration = 5000
    ) => {
      setIsTransitioning(true);

      setTimeout(() => {
        setIsTransitioning(false);
        actionAfterTransition();
      }, duration);
    };
  const goToNextPage = () => {
     setlearnerActivityrec((prev:any)=>
        updateScreenActivity(
          prev,
          12,
          "Character Selection",
          deviceInfo,
          {
            player_gender: selectedCharacter?.id,
            selectedplayer_charcter: selectedCharacter?.name,
            playernickname : formState.name,
          }
        )
      );
     try {
                const audio = new Audio(BtnClickSound as string);
                audio.volume = 1;
                audio.play().catch(() => { });

                // ⏱ Optional: Stop it after 2 seconds
                setTimeout(() => {
                    audio.pause();
                    audio.currentTime = 0;
                }, 1000);
            } catch (e) {
                // ignore audio errors
            }

              setCurrentScreenId(20);
      //commnet by kaviya
      //    startPortalTransition(() => {
     
    };

  

    //by kaviya
    useEffect(() => {
      const video = videoRef.current;
      if (!video || !showFloatingHub) return;

      const handleReady = () => {
        setIsTransitioning(false); // Hide transition
        video.play().catch(() => { });
      };

      video.addEventListener("canplaythrough", handleReady);

      return () => {
        video.removeEventListener("canplaythrough", handleReady);
      };
    }, [showFloatingHub]);

  const [playerToast, setPlayerToast] = useState<string | null>(null);
//by kaviya
useEffect(() => {
  const video = questVideoRef.current;
  if (!video || !showQuestHub) return;

  const handleReady = () => {
    setIsTransitioning(false);
    video.play().catch(() => {});
  };

  video.addEventListener("canplaythrough", handleReady);

  return () => {
    video.removeEventListener("canplaythrough", handleReady);
  };
}, [showQuestHub]);

//kaviya - new state
const [characterBlink, setCharacterBlink] = useState(false);
const [bottomBlink, setBottomBlink] = useState(false);


const bottomBlinkTimerRef = useRef<NodeJS.Timeout | null>(null);const triggerBottomBlink = () => {
  setBottomBlink(false);

  if (bottomBlinkTimerRef.current) {
    clearTimeout(bottomBlinkTimerRef.current);
  }

  bottomBlinkTimerRef.current = setTimeout(() => {
    if (formState.name.trim()) {
      setBottomBlink(true);
    }
  }, 6000);
};
    useEffect(() => {
  const timer = setTimeout(() => {
    setCharacterBlink(true);
  }, 6000);

  return () => clearTimeout(timer);
}, []);

const Toast = ({
  message,
  showPointer = true, // NEW PROP
}: {
  message: string;
  showPointer?: boolean;
}) => (
  <Box
    position="absolute"
    top="-68px"
    left="50%"
    transform="translateX(-50%)"
    minW="180px"
    maxW="460px"
    px="16px"
    py="12px"
    textAlign="center"
    borderRadius="10px"
    fontSize="12px"
    fontWeight="600"
    letterSpacing="0.4px"
    whiteSpace="normal"
    zIndex={1000}
    bg="rgba(10, 15, 30, 0.9)"
    // color="#3CFFC6"
    // border="2px solid #3CFFC6"
    backdropFilter="blur(6px)"
     color={primaryColor}
 boxShadow={`
      0 0 10px rgba(${hexToRgb(primaryColor)}, 0.8),
      0 0 25px rgba(${hexToRgb(primaryColor)}, 0.5),
      inset 0 0 10px rgba(${hexToRgb(primaryColor)}, 0.4)
    `}
    // boxShadow="
    //   0 0 10px rgba(60,255,198,0.8),
    //   0 0 25px rgba(60,255,198,0.5),
    //   inset 0 0 10px rgba(60,255,198,0.4)
    // "
  >
    {message}

    {showPointer && (
      <Box
        position="absolute"
        bottom="-12px"
        left="50%"
        transform="translateX(-50%) rotate(45deg)"
        width="100px"
        height="18px"
        bg="rgba(10, 15, 30, 0.95)"
        // borderRight="2px solid #3CFFC6"
        // borderBottom="2px solid #3CFFC6"
         borderRight={`2px solid ${primaryColor}`}   // ✅ theme color
          borderBottom={`2px solid ${primaryColor}`}
        boxShadow="0 0 10px rgba(60,255,198,0.8)"
      />
    )}
  </Box>
);




  const selectPlayerClick = async () => {
    // Your existing logic to select a player
    if (!formState.name.trim()) {
      // toast.error('Please Enter Your Name', {
      //   duration: 3000,
      //   position: 'top-right',
      // });
      setPlayerToast("Please enter your name");
setTimeout(() => setPlayerToast(null), 10000);
return;

    
    }

    const data = {
      learnerPlayList: {
        ...learnerPlayList,
        LearnerProfile: {
          ...learnerPlayList?.LearnerProfile,
          nickName: formState.name.trim(),
        },
      },
    };

    const dataString = JSON.stringify(data);
    const UpdateLearnerNickname = await updateLearnerNickName(dataString);

    if (
      UpdateLearnerNickname?.status === 'Success' &&
      UpdateLearnerNickname?.data
    ) {
      setLearnerPlayingDetails((prev: any) => ({
        ...prev,
        LearnerProfile: {
          ...prev.LearnerProfile,
          nickName: UpdateLearnerNickname?.data?.lenNickName,
        },
      }));
    }

    setProfileData((prev: any) => ({
      ...prev,
      name: formState.name,
    }));

    setTimeout(() => {
      setSelectedPlayer(players[0]);
      goToNextPage(); // Trigger the floating hub and video
    }, 300);
  };
useEffect(() => {
  if ((showFloatingHub || showQuestHub) && audioObj) {
    try {
      audioObj.pause();
      audioObj.currentTime = 0; // optional: reset
    } catch (e) {}
  }
}, [showFloatingHub, showQuestHub]);

   const handleInputChange = (e: any) => {
    const { value } = e.target;
    const trimmedValue = value.slice(0, 15);

    setFormState((prevState: any) => ({
      ...prevState,
      name: trimmedValue,
    }));
    setLearnerPlayingDetails((prevState: any) => ({
      ...prevState,
      LearnerProfile: {
        ...prevState.LearnerProfile,
        nickName: trimmedValue, // Set the new name as the nickname
      },
    }));
  };
    useEffect(() => {
  const timer = setTimeout(() => {
    setCharacterBlink(true);
  }, 6000);

  return () => clearTimeout(timer);
}, []);
  const [rightBlink, setRightBlink] = useState(false);

  useEffect(() => {}, [formState.name]);

  let theme: string | string[] = '';
  if ([1, 2, 3].includes(backgroundtheme?.gasId)) {
    theme = 'Medieval';
  } else if ([4, 5, 6].includes(backgroundtheme?.gasId)) {
    theme = 'Future';
  } else if ([10, 11, 12].includes(backgroundtheme?.gasId)) {
    theme = 'Real';
  } else if ([7, 8, 9].includes(backgroundtheme?.gasId)) {
    theme = ['Magical'];
  } else if ([149, 150, 151, 152].includes(backgroundtheme?.gasId)) {
    theme = ['FutureTheme'];
  }

  const matchingCharacter = preloadedAssets?.Player_Image?.filter((char: any) =>
    Array.isArray(theme) ? theme.includes(char.theme) : char.theme === theme,
  );


  const [blinking, setBlinking] = useState(false);

  const typingTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const [selectedCharacter, setSelectedCharacter] = useState(
    matchingCharacter[0],
  );

  const [selectedIndex, setSelectedIndex] = useState(0); // Initialize index as 0
  const choosegender =
    profileData?.gender && profileData?.gender === 'Female'
      ? preloadedAssets.Player_Image[1]
      : preloadedAssets.Player_Image[0];
  // const [selectedCharacter, setSelectedCharacter] = useState(preloadedAssets.Player_Image[0]);
  const [toggleLeftCharacter, setToggleLeftCharacter] = useState(false);
  const [toggleRightCharacter, setToggleRightCharacter] = useState(false);

  const getTexture = (selected: number): THREE.Texture => {
    const asset = selectedCharacter;

    return new THREE.TextureLoader().load(
      asset?.src || 'fallback-image-url.png',
    );
  };

  useEffect(() => {
    if (selectedCharacter?.id) {
      setProfileData((prev: any) => ({
        ...prev,
        gender: selectedCharacter?.id,
        selectedplayer: selectedCharacter?.name,
      }));
      setLearnerPlayingDetails((prev: any) => ({
        ...prev,

        player_gender: selectedCharacter?.id,
        selectedplayer_charcter: selectedCharacter?.name,
      }));
    }
  }, [selectedCharacter]);

  const prevCharacter = () => {
    setSelectedIndex((prevIndex) => {
      const newIndex =
        (prevIndex - 1 + matchingCharacter.length) % matchingCharacter.length;
      setSelectedCharacter(matchingCharacter[newIndex]);
      return newIndex;
    });
  };

  const nextCharacter = () => {
    setSelectedIndex((prevIndex) => {
      const newIndex = (prevIndex + 1) % matchingCharacter.length;
      setSelectedCharacter(matchingCharacter[newIndex]);
      return newIndex;
    });
  };
  const skipAllVideos = () => {
  try {
    // Stop any playing video
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }

    // Stop background audio
    if (audioObj) {
      audioObj.pause();
      audioObj.currentTime = 0;
    }

    stopAllAudio();
  } catch (e) {}

  // Reset states
  setShowFloatingHub(false);
  setShowQuestHub(false);
  setIsTransitioning(false);

  // Go directly to final screen
  setCurrentScreenId(13);
};


  const goToPreviousPage = () => {
      try {
                const audio = new Audio(BtnClickSound as string);
                audio.volume = 1;
                audio.play().catch(() => { });

                // ⏱ Optional: Stop it after 2 seconds
                setTimeout(() => {
                    audio.pause();
                    audio.currentTime = 0;
                }, 1000);
            } catch (e) {
                // ignore audio errors
            }
    setBlackScreen(true); // Trigger black screen fade effect
    setTimeout(() => {
      setCurrentScreenId(1); // Reflection page screen id
    }, 1000); // Delay 1 second for effect
  };

  const stopAllAudio = () => {
  // Stop <audio> tags
  const audios = document.querySelectorAll('audio');
  audios.forEach((audio) => {
    audio.pause();
    audio.currentTime = 0;
  });

  // Stop WebAudio contexts (if used)
  if ((window as any).AudioContext || (window as any).webkitAudioContext) {
    try {
      const AudioCtx =
        (window as any).AudioContext || (window as any).webkitAudioContext;
      const ctx = new AudioCtx();
      ctx.suspend();
    } catch (e) {}
  }
};
useEffect(() => {
  if (showFloatingHub) {
    stopAllAudio();
  }
}, [showFloatingHub]);
useEffect(() => {
  if (showQuestHub) {
    stopAllAudio();
  }
}, [showQuestHub]);



  return (
    <>
<style>
      {`
        @keyframes blinkGlow {
          0% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.15); opacity: 0.6; }
          100% { transform: scale(1); opacity: 1; }
        }
      `}
    </style>
    
        {isTransitioning && (
          <div className="fixed inset-0 z-[999999] flex items-center justify-center bg-black">
            <div
              className="hud-core hud-core-big"
           


            >
              <div className="hud-halo" />
              <div className="hud-ring hud-ring-outer" />
              <div className="hud-ring hud-ring-middle" />
              <div className="hud-ring hud-ring-inner" />
              <div className="hud-arc hud-arc-1" />
              <div className="hud-arc hud-arc-2" />
              <div className="hud-dot hud-dot-1" />
              <div className="hud-dot hud-dot-2" />
              <div className="hud-center" />
              <div className="hud-scan" />
            </div>
          </div>
        )}
    

      {playerToast && (
  <Box position="absolute" top="12%" left="50%" transform="translateX(-50%)" zIndex={99999999}>
    <Toast message={playerToast} showPointer={false} />
  </Box>
)}


      {/* <Toaster position="top-right"  /> */}
{(!showFloatingHub && !showQuestHub) && (
      <div
        className="relative h-screen w-full overflow-y-auto bg-black/90 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url('${imgBackground}')` }}
      >
        <div className="relative w-full px-4 sm:px-6 lg:px-8">
        
          {/* Character Selection Section */}
          <div className="flex h-screen pt-32">
            <div className="relative h-full flex-grow">
              <div className="lg:bottom-19 absolute bottom-14 left-1/2 z-20 w-full max-w-[27rem] -translate-x-1/2 transform">
                <p className="lg:top-22 glow-text relative top-20 text-center font-venora text-3xl font-bold tracking-wide text-white">
                  Select Character
                </p>

                <div className="relative top-10 mx-auto max-h-[calc(100svh-80px)] max-w-full text-center lg:top-12 lg:max-h-[45rem] lg:max-w-[25rem]">
                  <img
                    src={selectedCharacter?.src || '/placeholder.svg'}
                    alt={selectedCharacter?.name || 'character'}
                    className="select-none max-lg:mx-auto max-lg:max-h-[inherit] max-lg:w-auto lg:h-full lg:w-full lg:object-contain"
                  />
                </div>
                {/* Navigation Arrows */}
                <div className="absolute bottom-1/2 flex w-full -translate-y-2/2 transform items-center justify-between gap-3"
                style={{top:'26rem'}}>
                  <NavigationArrow direction="left" onClick={prevCharacter} />
                  <NavigationArrow direction="right" onClick={nextCharacter} isBlinking={characterBlink}  />
                </div>
              </div>

              {/* Glowing effect */}
              <div
                className="absolute bottom-12 left-1/2 h-[35.75rem] w-[26.375rem] -translate-x-1/2 transform rounded-full opacity-15 mix-blend-hard-light blur-[6.875rem]"
                style={{
                  background: primaryColor,
                }}
              />

              {/* Platform */}
              <div className="absolute bottom-0 w-full max-w-[80%] pl-[19%]">
                <img
                  src={imgPlatform || '/placeholder.svg'}
                  alt="platform"
                  className="h-full w-full object-contain"
                />
              </div>

              {/* Name Input */}
              <div className="absolute bottom-12 left-1/2 z-20 -translate-x-1/2 transform">
                <Card
                  className="relative h-16 w-80 rounded-lg border-none bg-[#1A1A1A]"
                  style={{
                    border: `1px solid rgba(${hexToRgb(primaryColor)}, 0.5)`,
                    boxShadow: `0px 0px 6px 1px rgba(${hexToRgb(
                      primaryColor,
                    )}, 0.5)`,
                  }}
                >
                  <div
                    className="absolute inset-2.5 flex items-center justify-center rounded-md px-0"
                    style={{
                      background: `rgba(${hexToRgb(primaryColor)}, 0.1)`,
                      border: `1px solid rgba(${hexToRgb(primaryColor)})`,
                      boxShadow: `inset 0px 0px 2.69259px 0px rgba(${hexToRgb(
                        primaryColor,
                      )}, 0.24)`,
                    }}
                  >
                    <Input
                      type="text"
                      value={formState.name}
                          // onChange={handleInputChange}
                           onChange={(e) => {
    handleInputChange(e);
    triggerBottomBlink();   // 👈 add this
  }}
                      placeholder="Enter Name"
                      className="font-glancyr-neue border-none bg-transparent pt-2 text-center !text-lg font-medium tracking-[0.07rem] text-white shadow-none outline-none placeholder:text-white/70 focus-visible:ring-0"
                    />
                  </div>
                </Card>
              </div>
            </div>
          </div>

          {/* Bottom Navigation */}
          <div className="absolute bottom-16 left-12 right-12 flex items-center justify-between">
            <NavigationArrow direction="left" onClick={goToPreviousPage} />
            <NavigationArrow
              direction="right"
              // onClick={goToNextPage}
              onClick={selectPlayerClick}
                isBlinking={bottomBlink}
            />
          </div>
        </div>
      </div>
)}
    </>
  );
};

export default CharacterSelectionFutureTheme;

